import TradingVenuesService from 'services/TradingVenuesService';
import enumsConstant from 'constants/enumsConstant';
import { clone } from 'utils';

const venueClasses = {
  [enumsConstant.tradingVenueGroup.icap]: 'icap-logo',
  [enumsConstant.tradingVenueGroup.tullet]: 'tullet-prebon-logo',
  [enumsConstant.tradingVenueGroup.pvm]: 'pvm-logo'
};

class TradingVenuesAdapter extends TradingVenuesService {
  backupTradingVenues = null;

  mapTradingVenues(venues) {
    return venues.map((item) => this.createTradingVenue(item));
  }

  createTradingVenue(item) {
    return {
      id: item.TradingVenueID,
      name: item.Name,
      type: item.Type,
      mic: item.MIC,
      tradingVenueGroupId: item.TradingVenueGroupID,
      hasTrades: item.HasTrades,
      hasOrders: item.HasOrders,
      venueClass: this.getVenueIconName(item.TradingVenueGroupID),
      isRealOrders: false,
      isRealTraders: false,
      isDelayedOrders: false,
      isDelayedTraders: false,
      isRealOrdersDisabled: false,
      isRealTradersDisabled: false,
      isDelayedOrdersDisabled: false,
      isDelayedTradersDisabled: false
    };
  }

  getVenueIconName(groupId) {
    return venueClasses[groupId];
  }

  loadTradingVenues() {
    if (this.backupTradingVenues) {
      return Promise.resolve(clone(this.backupTradingVenues));
    }

    return this.getList().then((result) => {
      const mappedVenues = this.mapTradingVenues(result.tradingVenues);
      // FIXME: remove hardcoded fallback value
      mappedVenues.realtimeOrderCost = mappedVenues.realtimeTradeCost = result.CostPerVenue || 25;
      this.backupTradingVenues = clone(mappedVenues);
      return mappedVenues;
    });
  }

  loadSubscriptionPrice(venues) {
    return super.getSubscriptionPrice(venues).then((result = {}) => {
      return { price: result.Price, subscriptionEndDate: result.SubscriptionEndDate };
    });
  }

  updateSubsriptions(venues) {
    return super.updateSubsriptions(venues).then((result) => {
      return {
        price: result.Price
      };
    });
  }

  loadSubscriptions() {
    return super.getSubscriptionList().then((response = {}) => {
      const result = { subscriptions: [], uncompletedPayments: [] };
      if (response && response.TradingVenuesList) {
        result.subscriptions = response.TradingVenuesList.reduce((acc, sub) => {
          const prevSub = acc[sub.TradingVenueID] || {};

          acc[sub.TradingVenueID] = {
            isRealOrders: prevSub.isRealOrders || sub.IsRealOrders,
            isRealTraders: prevSub.isRealTraders || sub.IsRealTraders,
            isDelayedOrders: prevSub.isDelayedOrders || sub.IsDelayedOrders,
            isDelayedTraders: prevSub.isDelayedTraders || sub.IsDelayedTraders,

            subscriptionEndDate: Math.max(prevSub.subscriptionEndDate || 0, sub.SubscriptionEndDate)
          };

          return acc;
        }, {});
      }

      if (response && response.UncompletedPayments) {
        result.uncompletedPayments = response.UncompletedPayments.map((payment) => {
          return {
            orderId: payment.OrderID,
            orderPrice: payment.OrderPrice,
            orderStatus: payment.OrderStatus
          };
        });
      }

      return result;
    });
  }
}

const instance = new TradingVenuesAdapter();

export default instance;



// WEBPACK FOOTER //
// ./src/adapters/TradingVenuesAdapter.js